import { render, staticRenderFns } from "./RoseSvg.vue?vue&type=template&id=35fc1224&scoped=true"
import script from "./RoseSvg.vue?vue&type=script&lang=js"
export * from "./RoseSvg.vue?vue&type=script&lang=js"
import style0 from "./RoseSvg.vue?vue&type=style&index=0&id=35fc1224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc1224",
  null
  
)

export default component.exports